import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    addLimitPage,
    initCurrentPage,
} from "../../features/videos/videosSlice";

export default function Pagination() {
    const dispatch = useDispatch();
    const { videos, totalPagination, currentPage } = useSelector(
        (state) => state.videos
    );

    const pagination = Array.from(Array(totalPagination).keys());
    const pageHandler = (page) => {
        dispatch(initCurrentPage(page));
    };

    // increase limit of page
    const pageLimitHandler = (e) => {
        dispatch(addLimitPage(e.target.value));
    };

    useEffect(() => {
        if (videos.length === 0) {
            dispatch(initCurrentPage(1));
        }
    }, [dispatch, videos]);

    // prev page handler
    const prevHandler = () => {
        if (currentPage !== 1) {
            dispatch(initCurrentPage(currentPage - 1));
        }
    };

    // next page handler
    const nextHandler = () => {
        if (currentPage !== totalPagination) {
            dispatch(initCurrentPage(currentPage + 1));
        }
    };

    return (
        <section className="pt-12">
            <div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex gap-2 justify-end">
                <div className="flex items-center gap-4">
                    <p className="text-sm text-gray-600">Page Limit :</p>
                    <select
                        onChange={pageLimitHandler}
                        className="h-8 border rounded focus:outline-none text-sm mr-8"
                    >
                        <option value="4">4</option>
                        <option value="6">6</option>
                        <option value="8">8</option>
                        <option value="10">10</option>
                    </select>
                </div>
                {currentPage > 1 && (
                    <button
                        onClick={prevHandler}
                        className="h-8 bg-green-600 text-white px-3 hover:bg-green-700 rounded-full"
                    >
                        Prev
                    </button>
                )}
                {pagination.length !== 0 &&
                    pagination.map((page, index) => (
                        <div
                            key={index}
                            onClick={() => pageHandler(page + 1)}
                            className={`${
                                currentPage === page + 1
                                    ? "bg-blue-600 "
                                    : "bg-blue-300 "
                            } text-white px-4 py-1 rounded-full cursor-pointer`}
                        >
                            {page + 1}
                        </div>
                    ))}
                {currentPage !== totalPagination && (
                    <button
                        onClick={nextHandler}
                        className="h-8 bg-green-600 text-white px-3 hover:bg-green-700 rounded-full"
                    >
                        Next
                    </button>
                )}
            </div>
        </section>
    );
}
